import { Component, HostListener, OnInit } from '@angular/core';
import { CheckAuth } from 'src/Services/utility.service';
import { CountyMasterService } from 'src/Services/county-master.service';
import { CountyMaster911Model } from 'src/Models/CountyMaster911Model';
import { Router } from '@angular/router';
import { StateMasterService } from 'src/Services/state-master.service';
import { StateMasterModel } from 'src/Models/stateMasterModel';
import { CityMasterService } from 'src/Services/city-master.service';
import { CityMaster911Model } from 'src/Models/CityMaster911Model';
import { ToastrService } from 'ngx-toastr';
import { Title } from '@angular/platform-browser';
import * as FileSaver from 'file-saver';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-city',
  templateUrl: './city.component.html',
  styleUrls: ['./city.component.css']
})
export class CityComponent implements OnInit {
  tokenKey: string;
  listofCity: CityMaster911Model[];
  listofCityExport: CityMaster911Model[];
  PageNumber: number = 1;
  PageSize: number = 10;
  isRecord: boolean = false;
  isloading: boolean = false;
  totalRecordCount: number = 0;
  stateId: string = '';
  filterText: string = '';
  SelectedTool: string;
  stateList: StateMasterModel[] = [];
  countyId: string = '';
  countyList: CountyMaster911Model[] = [];
  selectedCounty;
  orderBy: string = 'SortOrder';
  isAscending: boolean = false;
  upDowNameCSS: string = '';
  upDowStateNameCSS: string = '';
  upDowCountyNameCSS: string = '';
  upDowActiveCSS: string = '';
  upDowSortCSS: string = '';
  dropdownListState = [];
  selectedItemsState = [];
  dropdownSettingsState = {};
  listOfStateIds = [];
  selectedItemsConuty = [];
  selectedItemsCounty = [];
  dropdownSettingsCounty = {};
  listOfCountyIds = [];
  module = '911';
  cityId: number = 0;
  openMenuIndex: number = -1;

  constructor(private readonly countyService: CountyMasterService, private readonly toastr: ToastrService, private readonly stateService: StateMasterService, private readonly router: Router, private readonly checkAuth: CheckAuth, private readonly cityService: CityMasterService, private readonly titleService: Title, private sessionStorageService: SessionStorageService) {
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.SelectedTool = this.sessionStorageService.getUserLoginTool();
    this.titleService.setTitle('City');
    this.PageNumber = 1;
    this.PageSize = 10;

  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  ngOnInit() {
    this.dropdownSettingsState = {
      singleSelection: false,
      text: "Filter by Jurisdiction",
      enableSearchFilter: true,
      classes: "borderLessTextBoxGreen",
      badgeShowLimit: 3,
      noDataLabel: 'No Jurisdiction(s) available',
      showCheckbox: true
    };
    this.dropdownSettingsCounty = {
      singleSelection: false,
      text: "Filter by County",
      enableSearchFilter: true,
      classes: "borderLessTextBoxGreen",
      badgeShowLimit: 3,
      noDataLabel: 'No County(s) available',
      showCheckbox: true
    };
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.getState();
    this.GetAllCity();
  }

  keywordFilters($event) {
    this.filterText = $event.target.value;
    this.PageNumber = 1;
    this.GetAllCity();
  }

  pageChanged($event: any) {
    this.PageNumber = parseInt($event.page);
    this.GetAllCity();
  }

  GetAllCity() {
    this.isloading = true;
    this.listofCity = [];
    this.stateId = '';
    if (this.listOfStateIds.length > 0) {
      this.stateId = this.listOfStateIds.join(',')
    }
    this.countyId = '';
    if (this.listOfCountyIds.length > 0) {
      this.countyId = this.listOfCountyIds.join(',')
    }
    this.cityService.GetAllCity(this.tokenKey, this.PageNumber, this.PageSize, this.filterText, this.stateId, this.countyId, this.orderBy, false).subscribe(
      data => {
        this.isloading = false;
        this.listofCity = data['city'];
        if (this.listofCity != null) {
          if (this.listofCity.length == 0)
            this.isRecord = true;
          else {
            this.isRecord = false;
            this.totalRecordCount = this.listofCity[0].totalRecordCount;
          }
        }
        else
          this.isRecord = true;
      },
      error => { }
    );
  }

  addCity() {
    let navigation = '/admin/' + this.SelectedTool + '/city/manage';
    this.router.navigate([navigation]);
  }

  updateCity(cityId) {
    let navigation = '/admin/' + this.SelectedTool + '/city/manage/' + cityId;
    this.router.navigate([navigation]);
  }

  setDeleteData(id) {
    this.cityId = id;
  }

  deleteCity(cityId) {
    this.isloading = true;
    this.cityService.DeleteCity(this.tokenKey, cityId).subscribe(
      data => {
        this.GetAllCity();
        this.toastr.success('City deleted successfully.', 'Delete')
      },
      error => { }
    );
  }

  getState() {
    this.stateService.GetStateMaster(this.tokenKey, this.module).subscribe(
      data => {
        this.stateList = data['state'];
        this.dropdownListState = [];
        if (this.stateList.length > 0) {
          this.stateList.forEach(x => {
            this.dropdownListState.push({ "id": x.stateId, "itemName": x.name });
          });
        }
      },
      error => { }
    );
  }

  removeElemetninArray(array, element) {
    return array.filter(e => e !== element);
  }

  onSelectState($event) {
    this.listOfStateIds = this.removeElemetninArray(this.listOfStateIds, $event.id)
    this.listOfStateIds.push($event.id);
    this.stateId = '';
    if (this.listOfStateIds.length > 0) {
      this.stateId = this.listOfStateIds.join(',')
    }
    this.PageNumber = 1;
    this.GetCountyByStateId(this.stateId);
    this.GetAllCity();
  }

  onDeSelectState($event) {
    if (this.listOfStateIds != null) {
      if (this.listOfStateIds.length > 0) {
        this.listOfStateIds = this.removeElemetninArray(this.listOfStateIds, $event.id)
      }
    }
    if (this.listOfStateIds.length > 0) {
      this.stateId = this.listOfStateIds.join(',')
    }
    if (this.listOfStateIds.length == 0) {
      this.selectedItemsConuty = [];
      this.selectedItemsCounty = [];
      this.listOfCountyIds = [];
    }
    else {
      this.GetCountyByStateId(this.stateId);
    }

    this.PageNumber = 1;
    this.GetAllCity();
  }

  onSelectAll($event) {
    for (const item of $event) {
      if (this.listOfStateIds != null) {
        if (this.listOfStateIds.length > 0) {
          this.listOfStateIds = this.removeElemetninArray(this.listOfStateIds, item.id)
          this.listOfStateIds.push(item.id);
        }
        else {
          this.listOfStateIds.push(item.id);
        }
      }
    }
    if (this.listOfStateIds.length > 0) {
      this.stateId = this.listOfStateIds.join(',')
    }
    this.PageNumber = 1;
    this.GetCountyByStateId(this.stateId);
    this.GetAllCity();
  }

  onDeSelectAllState($event) {
    this.listOfStateIds = [];
    this.listOfCountyIds = [];
    this.selectedItemsCounty = [];
    this.selectedItemsConuty = [];
    this.PageNumber = 1;
    this.GetAllCity();
  }

  onSelectCounty($event) {
    this.listOfCountyIds = this.removeElemetninArray(this.listOfCountyIds, $event.id)
    this.listOfCountyIds.push($event.id);
    this.stateId = '';
    if (this.listOfCountyIds.length > 0) {
      this.stateId = this.listOfCountyIds.join(',')
    }
    this.PageNumber = 1;
    this.GetAllCity();
  }

  onDeSelectCounty($event) {
    if (this.listOfCountyIds != null) {
      if (this.listOfCountyIds.length > 0) {
        this.listOfCountyIds = this.removeElemetninArray(this.listOfCountyIds, $event.id)
      }
    }
    if (this.listOfCountyIds.length > 0) {
      this.stateId = this.listOfCountyIds.join(',')
    }
    this.PageNumber = 1;
    this.GetAllCity();
  }

  onSelectAllCounty($event) {
    for (const item of $event) {
      if (this.listOfCountyIds != null) {
        if (this.listOfCountyIds.length > 0) {
          this.listOfCountyIds = this.removeElemetninArray(this.listOfCountyIds, item.id)
          this.listOfCountyIds.push(item.id);
        }
        else {
          this.listOfCountyIds.push(item.id);
        }
      }
    }
    this.PageNumber = 1;
    this.GetAllCity();
  }

  onDeSelectAllCounty($event) {
    this.listOfCountyIds = [];
    this.PageNumber = 1;
    this.GetAllCity();
  }

  GetCountyByStateId(stateId) {
    this.countyService.GetCountyByStateId(stateId, true).subscribe(
      result => {
        if (result['status'] == 'Success') {
          this.countyList = result['county'];
          this.selectedItemsConuty = [];
          if (this.countyList.length > 0) {
            let b = [];
            this.selectedItemsCounty = [];
            this.countyList.forEach(x => {
              let a = this.listOfCountyIds.filter(e => e == x.countyId);
              if (a.length > 0) {
                b.push(x.countyId);
                this.selectedItemsCounty.push({ "id": x.countyId, "itemName": x.countyName })
              }
              this.selectedItemsConuty.push({ "id": x.countyId, "itemName": x.countyName })
            });
            this.listOfCountyIds = b;
          }
          else {
            this.selectedItemsCounty = [];
            this.listOfCountyIds = [];
          }
        }
      });
  }


  sort(sortBy: string) {
    if (!this.isAscending) {
      this.isAscending = true;
      this.orderBy = sortBy + ' DESC';

      if (sortBy === "CityName") {
        this.upDowNameCSS = 'fa fa-arrow-down';
        this.upDowStateNameCSS = '';
        this.upDowCountyNameCSS = '';
        this.upDowSortCSS = '';
        this.upDowActiveCSS = '';
      }
      else if (sortBy === "B.Name") {
        this.upDowNameCSS = '';
        this.upDowStateNameCSS = 'fa fa-arrow-down';
        this.upDowCountyNameCSS = '';
        this.upDowSortCSS = '';
        this.upDowActiveCSS = '';
      }
      else if (sortBy === "CountyName") {
        this.upDowNameCSS = '';
        this.upDowStateNameCSS = '';
        this.upDowCountyNameCSS = 'fa fa-arrow-down';
        this.upDowSortCSS = '';
        this.upDowActiveCSS = '';
      }
      else if (sortBy === "sortOrder") {
        this.upDowNameCSS = '';
        this.upDowStateNameCSS = '';
        this.upDowCountyNameCSS = '';
        this.upDowSortCSS = 'fa fa-arrow-down';
        this.upDowActiveCSS = '';
      }
      else if (sortBy === "IsActive") {
        this.upDowNameCSS = '';
        this.upDowStateNameCSS = '';
        this.upDowCountyNameCSS = '';
        this.upDowSortCSS = '';
        this.upDowActiveCSS = 'fa fa-arrow-down';
      }
    }
    else {
      this.isAscending = false;
      this.orderBy = sortBy;

      if (sortBy === "CityName") {
        this.upDowNameCSS = 'fa fa-arrow-up';
        this.upDowStateNameCSS = '';
        this.upDowCountyNameCSS = '';
        this.upDowSortCSS = '';
        this.upDowActiveCSS = '';
      }
      else if (sortBy === "B.Name") {
        this.upDowNameCSS = '';
        this.upDowStateNameCSS = 'fa fa-arrow-up';
        this.upDowCountyNameCSS = '';
        this.upDowSortCSS = '';
        this.upDowActiveCSS = '';
      }
      else if (sortBy === "CountyName") {
        this.upDowNameCSS = '';
        this.upDowStateNameCSS = '';
        this.upDowCountyNameCSS = 'fa fa-arrow-up';
        this.upDowSortCSS = '';
        this.upDowActiveCSS = '';
      }
      else if (sortBy === "sortOrder") {
        this.upDowNameCSS = '';
        this.upDowStateNameCSS = '';
        this.upDowCountyNameCSS = '';
        this.upDowSortCSS = 'fa fa-arrow-up';
        this.upDowActiveCSS = '';
      }
      else if (sortBy === "IsActive") {
        this.upDowNameCSS = '';
        this.upDowStateNameCSS = '';
        this.upDowCountyNameCSS = '';
        this.upDowSortCSS = '';
        this.upDowActiveCSS = 'fa fa-arrow-up';
      }
    }
    this.PageNumber = 1;
    this.GetAllCity();
  }
  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
    else if (msgType == 'warning') {
      setTimeout(() => this.toastr.warning(msg, msgTitle));
    }
  }

  onFilterSelectAllState($event) {
    for (const item of $event) {
      if (this.listOfStateIds != null) {
        if (this.listOfStateIds.length > 0) {
          this.listOfStateIds = this.removeElemetninArray(this.listOfStateIds, item.id)
          this.listOfStateIds.push(item.id);
        }
        else {
          this.listOfStateIds.push(item.id);
        }
      }
    }
    if (this.listOfStateIds.length > 0) {
      this.stateId = this.listOfStateIds.join(',')
    }
    this.PageNumber = 1;
    this.GetCountyByStateId(this.stateId);
    this.GetAllCity();
  }

  onFilterDeSelectAllState($event) {
    for (const item of $event) {
      if (this.listOfStateIds != null) {
        if (this.listOfStateIds.length > 0) {
          this.listOfStateIds = this.removeElemetninArray(this.listOfStateIds, item.id)
        }
      }
    }
    if (this.listOfStateIds.length > 0) {
      this.stateId = this.listOfStateIds.join(',')
      this.GetCountyByStateId(this.stateId);
    }
    else {
      this.selectedItemsConuty = [];
    }
    this.PageNumber = 1;
    this.GetAllCity();
  }

  onFilterSelectAllCounty($event) {
    for (const item of $event) {
      if (this.listOfCountyIds != null) {
        if (this.listOfCountyIds.length > 0) {
          this.listOfCountyIds = this.removeElemetninArray(this.listOfCountyIds, item.id)
          this.listOfCountyIds.push(item.id);
        }
        else {
          this.listOfCountyIds.push(item.id);
        }
      }
    }
    this.PageNumber = 1;
    this.GetAllCity();
  }

  onFilterDeSelectAllCounty($event) {
    for (const item of $event) {
      if (this.listOfCountyIds != null) {
        if (this.listOfCountyIds.length > 0) {
          this.listOfCountyIds = this.removeElemetninArray(this.listOfCountyIds, item.id)
        }
      }
    }
    this.PageNumber = 1;
    this.GetAllCity();
  }

  toggleMenu(index: number) {
    this.openMenuIndex = this.openMenuIndex === index ? -1 : index;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.kebab-menu')) {
      this.openMenuIndex = null;
    }
  }

  Export911City() {
    this.isloading = true;
    this.listofCityExport = [];
    this.stateId = '';
    if (this.listOfStateIds.length > 0) {
      this.stateId = this.listOfStateIds.join(',')
    }
    this.countyId = '';
    if (this.listOfCountyIds.length > 0) {
      this.countyId = this.listOfCountyIds.join(',')
    }
    this.cityService.GetAllCity(this.tokenKey, this.PageNumber, this.PageSize, this.filterText, this.stateId, this.countyId, this.orderBy, true).subscribe(
      data => {
        this.listofCityExport = data['city'];
        if (this.listofCityExport != null) {
          if (this.listofCityExport.length > 0) {
            setTimeout(() => {
              this.Download911City();
              this.isloading = false;
            }, 3000);
          }
          else {
            this.isloading = false;
            this.toastr.error("No record found", "Error");
          }
        }
        else {
          this.isloading = false;
          this.toastr.error("No record found", "Error");
        }
      },
      error => {
        this.isloading = false;
        console.log(error);
      }
    );
  }

  Download911City() {
    let tableData = document.getElementById("ExportTable").innerHTML;

    var uri = 'data:application/vnd.ms-excel;base64,'
      , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body>{table}</body></html>'
      , base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
      , format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }
    let html = "<table><tr class='mainhead'> <td colspan='3'>";
    html += tableData;
    html += "</td></tr></table>";
    let name = 'Export911City';
    var ctx = { worksheet: name || 'Worksheet', table: html }
    FileSaver.saveAs((uri + base64(format(template, ctx))), "Export911City.xls");
  }
}
